import { AddIcon } from '@approvalmax/ui';
import { Box, Button, Flex, Text } from '@approvalmax/ui/src/components';
import { useSetAtom } from 'jotai';
import { domain } from 'modules/data';
import { memo, useCallback } from 'react';

import { useIsInRoles } from '../../hooks/useIsInRoles';
import { useReadOnlyCompany } from '../../hooks/useReadOnlyCompany';
import { connectBankAccountPopupOpenState } from '../ConnectBankAccountPopup/ConnectBankAccountPopup.states';
import { messages } from './NoBankAccountsPlaceholder.messages';

export const NoBankAccountsPlaceholder = memo(() => {
    const setNewBankAccountOpen = useSetAtom(connectBankAccountPopupOpenState);
    const isReadOnly = useReadOnlyCompany();
    const isAuditor = useIsInRoles(domain.CompanyUserRole.Auditor);

    const handleClick = useCallback(() => {
        setNewBankAccountOpen(true);
    }, [setNewBankAccountOpen]);

    return (
        <Flex height='100%' justifyContent='center' alignItems='center'>
            <Box bordered radius='medium' spacing='40 32' width={480}>
                <Flex alignItems='center' direction='column' spacing='24'>
                    <Text font='headline' fontSize='small' fontWeight='medium' textAlign='center'>
                        {messages.noBankAccountsYet}
                    </Text>

                    <Button
                        block
                        color='blue80'
                        size='large'
                        disabled={isReadOnly || isAuditor}
                        startIcon={<AddIcon />}
                        onClick={handleClick}
                    >
                        {messages.addBankAccount}
                    </Button>
                </Flex>
            </Box>
        </Flex>
    );
});

NoBankAccountsPlaceholder.displayName = 'NoBankAccountsPlaceholder';
